import Step5 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      patientAccompanyingSymptomsTypeList: [
        { title: 'درد قفسه سینه', id: 1 },
        { title: 'تنگی نفس', id: 2 },
        { title: 'درد شکمی', id: 3 },
        { title: 'سرگیجه', id: 4 },
        { title: 'سردرد ', id: 5 },

      ],
      patientAccompanyingSymptomsTypeList_2: [
        { title: 'تنگی نفس', id: 1 },
        { title: 'تب و لرز', id: 2 },
        { title: 'اختلال حسی حرکتی', id: 3 },
        { title: 'اختلال هوشیاری', id: 4 },
        { title: 'اختلال در حرکت صورت(F)', id: 5 },
        { title: 'اختلال در حرکت دست و پا(A)', id: 6 },
        { title: 'اختلال در تکلم(S)', id: 7 },
        { title: 'اختلال بینایی', id: 8 },
        { title: 'خونریزی', id: 9 },
        { title: 'سردرد', id: 10 },
        { title: 'درد قفسه سینه', id: 11 },
        { title: 'اسهال', id: 12 },
        { title: 'تشنج', id: 13 },
        { title: 'تهوع و استفراغ', id: 14 },
        { title: 'ضعف و بیحالی', id: 15 },
        { title: 'بیهوشی گذرا', id: 16 },
        { title: 'اختلال روانی', id: 17 },
        // { title: 'سایر', id: 18 },
      ],
      patientAccompanyingSymptomsTypeList_3: [
        { title: 'علائم  BE FAST', id: 1 },
        { title: 'تنگی نفس', id: 2 },
        { title: 'سرگیحه', id: 3 },
        { title: 'سردرد', id: 4 },
        { title: 'تهوع و استفراغ', id: 5 },
        { title: 'تعریق سرد', id: 6 },
        { title: 'گیجی و منگی', id: 7 },
        // { title: 'سایر', id: 18 },
      ],
      patientAccompanyingSymptomsTypeList_4: [
        { title: 'درد قفسه سینه', id: 1 },
        { title: 'تنگی نفس', id: 2 },
        { title: 'احساس ناراحتی در قفسه سینه', id: 3 },
        { title: 'اضطراب', id: 4 },
        { title: 'PND', id: 5 },
        { title: 'تهوع و استفراغ', id: 6 },
        { title: 'تعریق سرد', id: 7 },
        { title: 'گیجی و منگی', id: 8 },
        // { title: 'سایر', id: 18 },
      ],
      patientAccompanyingSymptomsTypeList_5: [
        { title: 'تاری دید', id: 1 },
        { title: 'درد دراپی گاستر', id: 2 },
        { title: 'سردرد شدید', id: 3 },
        { title: 'تهوع و استفراغ', id: 4 },
        { title: 'خونریزی واژینال', id: 5 },
        { title: 'لکه بینی', id: 6 },
        { title: 'تنگی نفس', id: 7 },
        { title: 'تعریق سرد', id: 8 },
        { title: 'گیجی و منگی', id: 9 },
        { title: 'درد قفسه سینه', id: 10 },
        { title: 'ضعف و بیحالی', id: 11 },
        { title: 'بیهوشی گذرا', id: 12 },
        { title: 'دردشکمی', id: 13 },
        { title: 'اختلال حسی حرکتی', id: 14 },
        { title: 'سرگیجه', id: 15 },
        { title: 'تب و لرز', id: 16 },
        { title: 'اسهال', id: 17 },
        { title: 'سردرد', id: 18 },
        { title: 'اختلال هوشیاری', id: 19 },
        { title: 'اختلال در حرکت صورت(F)', id: 20 },
        { title: 'اختلال در حرکت دست و پا(A)', id: 21 },
        { title: 'اختلال در تکلم', id: 22 },
        { title: 'اختلال در بینایی', id: 23 },
        { title: 'اختلال روانی', id: 24 },

        // { title: 'سایر', id: 18 },
      ],

      mainPatientAccompanyingSymptomsTypeList: [
        { title: 'احساس ناراحتی در قفسه سینه', id: 1 },
        { title: 'اضطراب', id: 2 },
        { title: 'PND', id: 3 },
        { title: 'تهوع و استفراغ', id: 4 },
        { title: 'تعریق سرد', id: 5 },
        { title: 'گیجی و منگی', id: 6 },
        { title: 'ضعف و بی حالی', id: 7 },
        { title: 'اختلال حسی و حرکتی', id: 8 },
        { title: 'بیهوشی گذرا', id: 9 },
        { title: 'تب و لرز', id: 10 },
        { title: 'اسهال', id: 11 },
        { title: 'اختلال هوشیاری', id: 12 },
        { title: 'اختلال در حرکت صورت (F) ', id: 13 },
        { title: 'اختلال در حرکت دست و پا (A) ', id: 14 },
        { title: 'اختلال در تکلم (S)', id: 15 },
        { title: 'اختلال بینایی', id: 16 },
        { title: 'اختلال روانی', id: 17 },
        // { title: 'سایر', id: 18 },
      ],

      all_PatientAccompanyingSymptomsTypeList: [
        { title: 'تاری دید', id: 1, for: [5] },
        { title: 'درد دراپی گاستر', id: 2, for: [5] },
        { title: 'خونریزی واژینال', id: 3, for: [5] },
        { title: 'لکه بینی', id: 4, for: [5] },
        { title: 'سردرد شدید', id: 5, for: [5] },
        { title: 'علائم  BE FAST', id: 6, hasDialog: true, for: [3], idDialog: 1 },
        { title: 'سردرد', id: 7, hasDialog: true, for: [1, 2, 3, 4, 5], idDialog: 2 },
        { title: 'سرگیجه', id: 8, hasDialog: true, for: [2, 3, 4, 5], idDialog: 3 },
        { title: 'درد قفسه سینه', id: 9, hasDialog: true, for: [1, 2, 3, 4, 5], idDialog: 4 },
        { title: 'تنگی نفس', id: 10, hasDialog: true, for: [2, 3, 4, 5], idDialog: 5 },
        // { title: 'درد شکمی', id: 11, hasDialog: true, for: [2, 3, 4, 5], idDialog: 6 },
        { title: 'تب و لرز', id: 12, for: [1, 2, 3, 4, 5] },
        { title: 'اختلال حسی و حرکتی', id: 13, for: [1, 2, 3, 4, 5] },
        { title: 'اختلال هوشیاری', id: 14, for: [1, 2, 3, 4, 5] },
        { title: 'اختلال در حرکت صورت(F)', id: 15, for: [1, 2, 4, 5] },
        { title: 'اختلال در حرکت دست و پا(A)', id: 16, for: [1, 2, 4, 5] },
        { title: 'اختلال در تکلم(S)', id: 17, for: [1, 2, 4, 5] },
        { title: 'اختلال بینایی', id: 18, for: [1, 2, 4, 5] },
        { title: 'اختلال روانی', id: 19, for: [2, 4, 5] },
        { title: 'خونریزی', id: 20, for: [1, 3] },
        { title: 'تشنج', id: 21, for: [1, 3] },
        { title: 'تهوع و استفراغ', id: 22, for: [1, 2, 3, 4, 5] },
        { title: 'ضعف و بی حالی', id: 23, for: [1, 2, 3, 4, 5] },
        { title: 'بیهوشی گذرا', id: 24, for: [1, 2, 3, 4, 5] },
        { title: 'تعریق سرد', id: 25, for: [2, 4, 5] },
        { title: 'گیجی و منگی', id: 26, for: [2, 4, 5] },
        { title: 'احساس ناراحتی در قفسه سینه', id: 27, for: [2, 4] },
        { title: 'اضطراب', id: 28, for: [2, 3, 4] },
        { title: 'اسهال', id: 29, for: [2, 3, 4, 5] },
        { title: 'PND', id: 30, for: [2, 4] },
        { title: 'سرفه', id: 31, for: [1, 3] },


      ],

      selectedPatientAccompanyingSymptomsTypeList: [],
      patientAccompanyingSymptom: new Step5.Step5(
        '',
        null,
        new Step5.PatientBeFastDetail(null, null, null, null, null),
        new Step5.patientRespiratoryDetail(null),
        new Step5.PatientChestPainDetail(null, null, null, null, null, null),
        new Step5.PatientHeadacheDetail(null, null, null),
        new Step5.PatientVertigoDetail(null, null, null),
        [],
        [],
        [],
        [],
      ),
      otherPatientAccompanyingSymptom: '',
      importedData: [],
      //other else of truma
      isBeFast: false,
      isHeadech: false,
      isDizziness: false,
      isChest: false,
      isBreath: false,
      //headech
      headechModal: false,
      selectedHeadacheOtherSpecifications: [],
      headacheOtherSpecificationsNoteFlag: false,
      selectedHeadacheIllnessHistories: [],
      headacheOtherSpecificationsNote: '',
      headacheType: null,
      headacheLocation: null,
      headacheOtherSign: null,
      //befast
      befastModal: false,
      befastImbalance: null,
      befastVisionChanges: null,
      befastSaggingFace: null,
      befastParalysis: null,
      befastTalkingProblem: null,
      //Vertigo
      vertigoModal: false,
      selectedVertigoOtherSpecifications: [],
      vertigoAggravatingFactor: null,
      vertigoDuration: null,
      vertigoType: null,
      vertigoOtherSpecificationsNoteFlag: false,
      vertigoOtherSpecificationsNote: '',
      //chest
      chestIsActivityPainTypeItmes: [
        { title: 'بله', id: 1, value: true },
        { title: 'خیر', id: 2, value: false },
      ],
      chestIsActivityPain: null,
      chestType: null,
      chestLocation: null,
      chestPropagation: null,
      chestPainDuration: null,
      chestPainScale: null,
      chestModal: false,
      //breath
      breathAcitivity: null,
      breathModal: false,
      //other
      otherAccompanyingSymptom: null,
      otherAccompanyingSymptomText: '',
    };
  },
  methods: {
    addOtherPatientAccompanyingSymptom: function () {
      if (!this.otherPatientAccompanyingSymptom) {
        this.showErrorAlert('سایر علائم نمی تواند خالی باشد');
        return;
      }
      if (!this.otherPatientAccompanyingSymptom.replace(/\s/g, '').length) {
        this.showErrorAlert('سایر علائم نمی تواند خالی باشد');
        return;
      }

      this.addPatientAccompanyingSymptomTrumaType(this.otherPatientAccompanyingSymptom);
    },
    addPatientAccompanyingSymptomTrumaType: function (title) {
      this.patientAccompanyingSymptom.title = title;
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail = null;
      this.patientAccompanyingSymptom.patientRespiratoryDetail = null;
      this.patientAccompanyingSymptom.patientChestPainDetail = null;
      this.patientAccompanyingSymptom.patientHeadacheDetail = null;
      this.patientAccompanyingSymptom.patientVertigoDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = null;
      this.patientAccompanyingSymptom.patientVertigoOtherSpecifications = null;
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },
    patientAccompanyingSymptomTrumaTypeAdded: function () {
      this.otherPatientAccompanyingSymptom = '';
      //headech
      this.headechModal = false;
      this.selectedHeadacheOtherSpecifications = [];
      this.headacheOtherSpecificationsNoteFlag = false;
      this.selectedHeadacheIllnessHistories = [];
      this.headacheOtherSpecificationsNote = '';
      this.headacheType = null;
      this.headacheLocation = null;
      this.headacheOtherSign = null;
      //befast
      this.befastModal = false;
      this.befastImbalance = null;
      this.befastVisionChanges = null;
      this.befastSaggingFace = null;
      this.befastParalysis = null;
      this.befastTalkingProblem = null;
      //vertigo
      this.vertigoModal = false;
      this.selectedVertigoOtherSpecifications = [];
      this.vertigoAggravatingFactor = null;
      this.vertigoDuration = null;
      this.vertigoType = null;
      this.vertigoOtherSpecificationsNoteFlag = false;
      this.vertigoOtherSpecificationsNote = '';
      //chest
      this.chestIsActivityPain = null;
      this.chestType = null;
      this.chestLocation = null;
      this.chestPropagation = null;
      this.chestPainDuration = null;
      this.chestPainScale = null;
      this.chestModal = false;
      //breath
      this.breathModal = false;
      this.breathAcitivity = null;
    },
    setData: function (data) {
      this.isBeFast = false;
      this.isHeadech = false;
      this.isDizziness = false;
      this.isChest = false;
      this.isBreath = false;
      this.importedData = [];
      this.patientAccompanyingSymptom = new Step5.Step5(
        '',
        null,
        new Step5.PatientBeFastDetail(null, null, null, null, null),
        new Step5.patientRespiratoryDetail(null),
        new Step5.PatientChestPainDetail(null, null, null, null, null, null),
        new Step5.PatientHeadacheDetail(null, null, null),
        new Step5.PatientVertigoDetail(null, null, null),
        [],
        [],
        [],
        [],
      );
      // if (this.missionType == 'truma') {ورژن قدیمی
      // if (this.localFlagShowForm !== 3) {//ورژن جدید
      //   this.selectedPatientAccompanyingSymptomsTypeList = [];
      //   for (let i = 0; i < data.length; i++) {
      //     let flag = false;
      //     for (let j = 0; j < this.patientAccompanyingSymptomsTypeList.length; j++) {
      //       if (data[i].title == this.patientAccompanyingSymptomsTypeList[j].title) {
      //         flag = true;
      //         this.selectedPatientAccompanyingSymptomsTypeList.push(data[i]);
      //         this.patientAccompanyingSymptomsTypeList.splice(j, 1);
      //       }
      //     }
      //     if (!flag) {
      //       this.selectedPatientAccompanyingSymptomsTypeList.push(data[i]);
      //     }
      //   }
      // } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].title == 'سردرد') {
          this.isHeadech = true;
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: 'سردرد',
            id: id,
            mainId: data[i].id,
            hasDetail: true,
            showDetail: false,
            info: [],
          });
          if (data[i].patientHeadacheDetail) {
            this.importedData[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheType.title,
              content: 'نوع درد',
              id: this.importedData[id - 1].info.length + 1,
            });
            this.importedData[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheLocation.title,
              content: 'محل درد',
              id: this.importedData[id - 1].info.length + 1,
            });
            this.importedData[id - 1].info.push({
              title: data[i].patientHeadacheDetail.headacheOtherSign.title,
              content: 'علائم همراه',
              id: this.importedData[id - 1].info.length + 1,
            });
          }
          if (data[i].patientHeadacheIllnessHistories.length > 0) {
            for (let j = 0; j < data[i].patientHeadacheIllnessHistories.length; j++) {
              this.importedData[id - 1].info.push({
                title: data[i].patientHeadacheIllnessHistories[j].headacheIllnessHistory.title,
                content: 'سابقه بیماری',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
          if (data[i].patientHeadacheOtherSpecificationDetails.length > 0) {
            for (let j = 0; j < data[i].patientHeadacheOtherSpecificationDetails.length; j++) {
              this.importedData[id - 1].info.push({
                title:
                  data[i].patientHeadacheOtherSpecificationDetails[j].headacheOtherSpecification
                    .title,
                content: 'سایر مشخصات',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
        } else if (data[i].title == 'BE FAST') {
          this.isBeFast = true;
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: 'BE FAST',
            id: id,
            mainId: data[i].id,
            hasDetail: true,
            showDetail: false,
            info: [],
          });
          if (data[i].patientBeFastDetail) {
            if (data[i].patientBeFastDetail.imbalance != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.imbalance == true) {
                text = 'بله';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'عدم تعادل',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
            if (data[i].patientBeFastDetail.visionChanges != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.visionChanges == true) {
                text = 'بله';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'تغییرات بینایی',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
            if (data[i].patientBeFastDetail.saggingFace != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.saggingFace == true) {
                text = 'بله';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'افتادگی صورت',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
            if (data[i].patientBeFastDetail.paralysis != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.paralysis == true) {
                text = 'بله';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'ضعف یا فلج اندام ها',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
            if (data[i].patientBeFastDetail.talkingProblem != null) {
              let text = 'خیر';
              if (data[i].patientBeFastDetail.talkingProblem == true) {
                text = 'بله';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'اشکال در صحبت کردن',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
        } else if (data[i].title == 'سرگیجه') {
          this.isDizziness = true;
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: 'سرگیجه',
            id: id,
            mainId: data[i].id,
            hasDetail: true,
            showDetail: false,
            info: [],
          });
          if (data[i].patientVertigoDetail) {
            this.importedData[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoType.title,
              content: 'نوع سرگیجه',
              id: this.importedData[id - 1].info.length + 1,
            });
            this.importedData[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoDuration.title,
              content: 'مدت سرگیجه',
              id: this.importedData[id - 1].info.length + 1,
            });
            this.importedData[id - 1].info.push({
              title: data[i].patientVertigoDetail.vertigoAggravatingFactor.title,
              content: 'عامل تشدید کننده',
              id: this.importedData[id - 1].info.length + 1,
            });
          }
          if (data[i].patientVertigoOtherSpecifications.length > 0) {
            for (let j = 0; j < data[i].patientVertigoOtherSpecifications.length; j++) {
              this.importedData[id - 1].info.push({
                title:
                  data[i].patientVertigoOtherSpecifications[j].vertigoOtherSpecification.title,
                content: 'سایر مشخصات',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
        } else if (data[i].title == 'درد قفسه سینه') {
          this.isChest = true;
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: 'درد قفسه سینه',
            id: id,
            mainId: data[i].id,
            hasDetail: true,
            showDetail: false,
            info: [],
          });
          if (data[i].patientChestPainDetail) {
            if (data[i].patientChestPainDetail) {
              if (data[i].patientChestPainDetail.isActivityPain != null) {
                let text = 'ندارد';
                if (data[i].patientChestPainDetail.isActivityPain == true) {
                  text = 'دارد';
                }
                this.importedData[id - 1].info.push({
                  title: text,
                  content: 'درد فعالیتی',
                  id: this.importedData[id - 1].info.length + 1,
                });
              }
              this.importedData[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainType.title,
                content: 'نوع درد',
                id: this.importedData[id - 1].info.length + 1,
              });
              this.importedData[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainLocation.title,
                content: 'محل درد',
                id: this.importedData[id - 1].info.length + 1,
              });
              this.importedData[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainPropagation.title,
                content: 'انتشار درد',
                id: this.importedData[id - 1].info.length + 1,
              });
              this.importedData[id - 1].info.push({
                title: data[i].patientChestPainDetail.chestPainDuration.title,
                content: 'مدت',
                id: this.importedData[id - 1].info.length + 1,
              });
              this.importedData[id - 1].info.push({
                title: data[i].patientChestPainDetail.painScale,
                content: 'نمره درد',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
        } else if (data[i].title == 'تنگی نفس') {
          this.isBreath = true;
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: 'تنگی نفس',
            id: id,
            mainId: data[i].id,
            hasDetail: true,
            showDetail: false,
            info: [],
          });
          if (data[i].patientRespiratoryDetail) {
            if (data[i].patientRespiratoryDetail.hasActivityBreathProblem != null) {
              let text = 'ندارد';
              if (data[i].patientRespiratoryDetail.hasActivityBreathProblem == true) {
                text = 'دارد';
              }
              this.importedData[id - 1].info.push({
                title: text,
                content: 'تنگی نفس فعالیتی',
                id: this.importedData[id - 1].info.length + 1,
              });
            }
          }
        } else {
          const id = this.importedData.length + 1;
          this.importedData.push({
            title: data[i].title,
            id: id,
            mainId: data[i].id,
            hasDetail: false,
            showDetail: false,
            info: [],
          });
        }
      }
      // }

    },
    removeItem: function (title) {
      for (let i = 0; i < this.mainPatientAccompanyingSymptomsTypeList.length; i++) {
        if (title == this.mainPatientAccompanyingSymptomsTypeList[i].title) {
          this.patientAccompanyingSymptomsTypeList.push({
            title: title,
            id: this.patientAccompanyingSymptomsTypeList.length + 1,
          });
        }
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(2, true);
    },
    backToStep4: function () {
      this.$root.$refs.FollowUpPatient.changeTab(1);
      this.$root.$refs.FollowUpPatient.changeTab1Step(4, true);
    },
    //other else truma
    changePatientAccompanyingSymptomType: function (type) {
      if (type == 1) {
        this.showBefastModal();
        this.isBeFast = true;
      } else if (type == 2) {
        this.showHeadacheModal();
        this.isHeadech = true;
      } else if (type == 3) {
        this.showVertigoModal();
        this.isDizziness = true;
      } else if (type == 4) {
        this.showChestModal();
        this.isChest = true;
      } else if (type == 5) {
        this.showBreathModal();
        this.isBreath = true;
      }
    },
    //headache
    headacheOtherSpecificationsChange: function () {
      if (
        this.selectedHeadacheOtherSpecifications.includes('همراهی سردرد با سایر علائم نورولوژیک')
      ) {
        this.headacheOtherSpecificationsNoteFlag = true;
        this.headacheOtherSpecificationsNote = '';
      } else {
        this.headacheOtherSpecificationsNoteFlag = false;
        this.headacheOtherSpecificationsNote = '';
      }
    },
    showHeadacheModal: function () {
      this.getListOfHeadacheLocationsForOther();
      this.getListOfHeadacheOtherSignsForOther();
      this.getListOfHeadacheTypesForOther();
      this.getListOfHeadacheOtherSpecificationsForOther();
      this.getListOfHeadacheIllnessHistoriesForOther();
      this.headechModal = true;
    },
    addHeadache: function () {
      if (!this.headacheType) {
        this.showErrorAlert('نوع درد نمی تواند خالی باشد');
        return;
      }
      if (!this.headacheLocation) {
        this.showErrorAlert('محل درد نمی تواند خالی باشد');
        return;
      }
      if (!this.headacheOtherSign) {
        this.showErrorAlert('علائم همراه نمی تواند خالی باشد');
        return;
      }
      this.patientAccompanyingSymptom.title = 'سردرد';
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail = null;
      this.patientAccompanyingSymptom.patientRespiratoryDetail = null;
      this.patientAccompanyingSymptom.patientChestPainDetail = null;
      this.patientAccompanyingSymptom.patientHeadacheDetail.headacheTypeId = this.headacheType.id;
      this.patientAccompanyingSymptom.patientHeadacheDetail.headacheLocationId =
        this.headacheLocation.id;
      this.patientAccompanyingSymptom.patientHeadacheDetail.headacheOtherSignId =
        this.headacheOtherSign.id;
      this.patientAccompanyingSymptom.patientVertigoDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientVertigoOtherSpecifications = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = [];
      for (let i = 0; i < this.selectedHeadacheOtherSpecifications.length; i++) {
        for (let j = 0; j < this.allHeadacheOtherSpecificationsForOther.length; j++) {
          if (
            this.allHeadacheOtherSpecificationsForOther[j].title ==
            this.selectedHeadacheOtherSpecifications[i]
          ) {
            if (this.allHeadacheOtherSpecificationsForOther[j].id == 5) {
              this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails.push(
                new Step5.PatientHeadacheOtherSpecificationDetails(
                  this.allHeadacheOtherSpecificationsForOther[j].id,
                  this.headacheOtherSpecificationsNote,
                ),
              );
            } else {
              this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails.push(
                new Step5.PatientHeadacheOtherSpecificationDetails(
                  this.allHeadacheOtherSpecificationsForOther[j].id,
                  '',
                ),
              );
            }
          }
        }
      }
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = [];
      for (let i = 0; i < this.selectedHeadacheIllnessHistories.length; i++) {
        for (let j = 0; j < this.allHeadacheIllnessHistoriesForOther.length; j++) {
          if (
            this.allHeadacheIllnessHistoriesForOther[j].title ==
            this.selectedHeadacheIllnessHistories[i]
          ) {
            this.patientAccompanyingSymptom.patientHeadacheIllnessHistories.push(
              new Step5.PatientHeadacheIllnessHistories(
                this.allHeadacheIllnessHistoriesForOther[j].id,
              ),
            );
          }
        }
      }
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },

    cancelAddHeadache: function () {
      this.selectedHeadacheOtherSpecifications = [];
      this.headacheOtherSpecificationsNoteFlag = false;
      this.selectedHeadacheIllnessHistories = [];
      this.headacheOtherSpecificationsNote = '';
      this.headacheType = null;
      this.headacheLocation = null;
      this.headacheOtherSign = null;
      this.headechModal = false;
      this.isHeadech = false;
    },
    //befast
    showBefastModal: function () {
      this.befastModal = true;
    },
    addBefast: function () {
      this.patientAccompanyingSymptom.title = 'BE FAST';
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail.imbalance = this.befastImbalance;
      this.patientAccompanyingSymptom.patientBeFastDetail.visionChanges = this.befastVisionChanges;
      this.patientAccompanyingSymptom.patientBeFastDetail.saggingFace = this.befastSaggingFace;
      this.patientAccompanyingSymptom.patientBeFastDetail.paralysis = this.befastParalysis;
      this.patientAccompanyingSymptom.patientBeFastDetail.talkingProblem =
        this.befastTalkingProblem;
      this.patientAccompanyingSymptom.patientRespiratoryDetail = null;
      this.patientAccompanyingSymptom.patientChestPainDetail = null;
      this.patientAccompanyingSymptom.patientHeadacheDetail = null;
      this.patientAccompanyingSymptom.patientVertigoDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = null;
      this.patientAccompanyingSymptom.patientVertigoOtherSpecifications = null;
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },
    cancelAddBefast: function () {
      this.befastModal = false;
      this.befastImbalance = null;
      this.befastVisionChanges = null;
      this.befastSaggingFace = null;
      this.befastParalysis = null;
      this.befastTalkingProblem = null;
      this.isBeFast = false;
    },
    //vertigo
    showVertigoModal: function () {
      this.getListOfVertigoTypesForOther();
      this.getListOfVertigoOtherSpecificationsForOther();
      this.getListOfVertigoDurationsForOther();
      this.getListOfVertigoAggravatingFactorsForOther();
      this.vertigoModal = true;
    },
    vertigoOtherSpecificationsChange: function () {
      if (this.selectedVertigoOtherSpecifications.includes('همراهی سردرد با سایر علائم نورولوژیک')) {
        this.vertigoOtherSpecificationsNoteFlag = true;
        this.vertigoOtherSpecificationsNote = '';
      } else {
        this.vertigoOtherSpecificationsNoteFlag = false;
        this.vertigoOtherSpecificationsNote = '';
      }
    },
    addVertigo: function () {
      if (!this.vertigoType) {
        this.showErrorAlert('نوع سرگیجه نمی تواند خالی باشد');
        return;
      }
      if (!this.vertigoDuration) {
        this.showErrorAlert('مدت هر حمله سرگیجه نمی تواند خالی باشد');
        return;
      }
      if (!this.vertigoAggravatingFactor) {
        this.showErrorAlert('عامل تشدید کننده نمی تواند خالی باشد');
        return;
      }
      this.patientAccompanyingSymptom.title = 'سرگیجه';
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail = null;
      this.patientAccompanyingSymptom.patientRespiratoryDetail = null;
      this.patientAccompanyingSymptom.patientChestPainDetail = null;
      this.patientAccompanyingSymptom.patientHeadacheDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = null;
      this.patientAccompanyingSymptom.patientVertigoDetail.vertigoTypeId = this.vertigoType.id;
      this.patientAccompanyingSymptom.patientVertigoDetail.vertigoDurationId =
        this.vertigoDuration.id;
      this.patientAccompanyingSymptom.patientVertigoDetail.vertigoAggravatingFactorId =
        this.vertigoAggravatingFactor.id;
      for (let i = 0; i < this.selectedVertigoOtherSpecifications.length; i++) {
        for (let j = 0; j < this.allVertigoOtherSpecificationsForOther.length; j++) {
          if (
            this.allVertigoOtherSpecificationsForOther[j].title ==
            this.selectedVertigoOtherSpecifications[i]
          ) {
            if (this.selectedVertigoOtherSpecifications[i] == 'همراهی با سایر علائم نورولوژیک') {
              this.patientAccompanyingSymptom.patientVertigoOtherSpecifications.push(
                new Step5.PatientVertigoOtherSpecifications(
                  this.allVertigoOtherSpecificationsForOther[j].id,
                  this.vertigoOtherSpecificationsNote,
                ),
              );
            } else {
              this.patientAccompanyingSymptom.patientVertigoOtherSpecifications.push(
                new Step5.PatientVertigoOtherSpecifications(
                  this.allVertigoOtherSpecificationsForOther[j].id,
                  '',
                ),
              );
            }
          }
        }
      }
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },
    canceAddVertigo: function () {
      this.vertigoModal = false;
      this.selectedVertigoOtherSpecifications = [];
      this.vertigoAggravatingFactor = null;
      this.vertigoDuration = null;
      this.vertigoType = null;
      this.isDizziness = false;
      this.vertigoOtherSpecificationsNoteFlag = false;
      this.vertigoOtherSpecificationsNote = '';
    },
    //chest
    showChestModal: function () {
      this.getListOfChestPainDurationsForOther();
      this.getListOfChestPainLocationsForOther();
      this.getListOfChestPainPropagationsForOther();
      this.getListOfChestPainTypesForOther();
      this.chestModal = true;
    },
    addChest: function () {
      if (!this.chestIsActivityPain) {
        this.showErrorAlert('درد فعالیتی نمی تواند خالی باشد');
        return;
      }
      if (!this.chestType) {
        this.showErrorAlert('نوع درد نمی تواند خالی باشد');
        return;
      }
      if (!this.chestLocation) {
        this.showErrorAlert('محل درد نمی تواند خالی باشد');
        return;
      }
      if (!this.chestPropagation) {
        this.showErrorAlert('انتشار درد نمی تواند خالی باشد');
        return;
      }
      if (!this.chestPainDuration) {
        this.showErrorAlert('مدت نمی تواند خالی باشد');
        return;
      }
      if (!this.chestPainScale) {
        this.showErrorAlert('نمره درد نمی تواند خالی باشد');
        return;
      }
      this.patientAccompanyingSymptom.title = 'درد قفسه سینه';
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail = null;
      this.patientAccompanyingSymptom.patientRespiratoryDetail = null;
      this.patientAccompanyingSymptom.patientChestPainDetail.isActivityPain =
        this.chestIsActivityPain.value;
      this.patientAccompanyingSymptom.patientChestPainDetail.chestPainTypeId = this.chestType.id;
      this.patientAccompanyingSymptom.patientChestPainDetail.chestPainLocationId =
        this.chestLocation.id;
      this.patientAccompanyingSymptom.patientChestPainDetail.chestPainPropagationId =
        this.chestPropagation.id;
      this.patientAccompanyingSymptom.patientChestPainDetail.chestPainDurationId =
        this.chestPainDuration.id;
      this.patientAccompanyingSymptom.patientChestPainDetail.painScale = this.chestPainScale;
      this.patientAccompanyingSymptom.patientHeadacheDetail = null;
      this.patientAccompanyingSymptom.patientVertigoDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = null;
      this.patientAccompanyingSymptom.patientVertigoOtherSpecifications = null;
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },
    cancelAddChest: function () {
      this.chestIsActivityPain = null;
      this.chestType = null;
      this.chestLocation = null;
      this.chestPropagation = null;
      this.chestPainDuration = null;
      this.chestPainScale = null;
      this.chestModal = false;
      this.isChest = false;
    },
    //breath
    showBreathModal: function () {
      this.breathModal = true;
    },
    addBreath: function () {
      this.patientAccompanyingSymptom.title = 'تنگی نفس';
      this.patientAccompanyingSymptom.patientId = this.patientId;
      this.patientAccompanyingSymptom.patientBeFastDetail = null;
      this.patientAccompanyingSymptom.patientRespiratoryDetail.hasActivityBreathProblem =
        this.breathAcitivity;
      this.patientAccompanyingSymptom.patientChestPainDetail = null;
      this.patientAccompanyingSymptom.patientHeadacheDetail = null;
      this.patientAccompanyingSymptom.patientVertigoDetail = null;
      this.patientAccompanyingSymptom.patientAbdomenPainDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheOtherSpecificationDetails = null;
      this.patientAccompanyingSymptom.patientHeadacheIllnessHistories = null;
      this.patientAccompanyingSymptom.patientVertigoOtherSpecifications = null;
      this.addPatientAccompanyingSymptomFunction(this.patientAccompanyingSymptom);
    },
    cancelAddBreath: function () {
      this.breathModal = false;
      this.breathAcitivity = null;
      this.isBreath = false;
    },
    openDetail: function (id) {
      for (let i = 0; i < this.importedData.length; i++) {
        if (id == this.importedData[i].mainId) {
          this.importedData[i].showDetail = true;
        }
      }
    },
    closeDetail: function (id) {
      for (let i = 0; i < this.importedData.length; i++) {
        if (id == this.importedData[i].mainId) {
          this.importedData[i].showDetail = false;
        }
      }
    },
    // other patientAccompanyingSymptom
    addOtherPatientAccompanyingSymptomNotTruma: function () {
      // if (this.otherAccompanyingSymptom === 'سایر')
      this.otherAccompanyingSymptom = this.otherAccompanyingSymptomText;
      this.addPatientAccompanyingSymptomTrumaType(this.otherAccompanyingSymptom);
    },
  },
};
